import React from "react";
import logo from "../../media/green-right-small-logo_1.png";
export default function ReusableContactFooter() {
  return (
    <div className="contactSection">
      <h3>
        For GTA: Call us at{" "}
        <span className="companyAccent">
          <a href="tel:+4162365686">416-236-5686</a>{" "}
        </span>
      </h3>
      <h3>
        For Cambridge, Guelph, KW: Call us at{" "}
        <span className="companyAccent">
          <a href="tel:+2263393998">226-339-3998</a>
        </span>
      </h3>
      <img src={logo} alt="Green Right Window Cleaning logo" />
    </div>
  );
}
